<template>
  <DocumentFormSection id="operational-title" :required="true" :show-description="false" :slot-max-width="1000">
    <OptionNameCommercialEdit
      :model-value="operationalTranslation?.name || ''"
      :offer-name="operationalTranslation?.name || ''"
      :offer-title="undefined"
      readonly
    />
  </DocumentFormSection>

  <DocumentFormSection
    v-if="relatedOptionNames.length > 0"
    id="operational-option-names"
    class="bg-neutral-30 p-4 border border-neutral-60 rounded-md"
    :required="true"
    :show-description="false"
    :slot-max-width="1000"
  >
    <div v-for="option in relatedOptionNames" :key="option.option_id" class="mt-4 first:mt-0">
      <OptionNameCommercialEdit
        :model-value="option.name || ''"
        class="w-full"
        :offer-name="option.name || ''"
        :offer-title="undefined"
        readonly
      />
    </div>
  </DocumentFormSection>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DocumentFormSection from "@/components/Document/FormSection/FormSection.vue";
import OptionNameCommercialEdit from "@/features/experience-curation/option-names/components/OptionNameCommercialEdit.vue";
import { RevisionFormProps } from "../types/forms";

const props = defineProps<RevisionFormProps>();
const route = useRoute();

const operationalId = computed(() => {
  const form = route.params.form as string;
  return form.replace("operational-", "");
});

const operationalTranslation = computed(() =>
  props.values?.operationalTranslations?.find((ot) => ot.operational_id === operationalId.value)
);

const relatedOptionNames = computed(() =>
  (props.values?.optionNames ?? []).filter((opt) => opt.operational_id === operationalId.value)
);
</script>
